import { useState } from 'react';
import { useBrandLogoCache } from '~/context/brand-logo-context';
import { brandLogoBackground } from '~/utils/get-filler-image';

export default function BrandLogo({
  name,
  prominent = false,
}: {
  name: string;
  prominent?: boolean;
}) {
  const { getBrandLogo } = useBrandLogoCache();
  const logo = getBrandLogo(name);
  const [failedLogo, setFailedLogo] = useState<string | null>(null);
  const hasLogo = !!logo && failedLogo !== logo;

  if (prominent && !hasLogo) return null;

  return (
    <span
      aria-hidden="true"
      className={`flex shrink-0 items-center justify-center rounded ${prominent ? 'h-16 w-20 p-2 md:h-20 md:w-24' : 'h-10 w-12 p-1'} ${hasLogo ? brandLogoBackground(name) : ''}`}
    >
      {hasLogo && (
        <img
          src={logo}
          alt=""
          loading={prominent ? 'eager' : 'lazy'}
          decoding="async"
          className="h-full w-full object-contain"
          onError={() => setFailedLogo(logo)}
        />
      )}
    </span>
  );
}
